<template>
  <div>
    <div>{{ row.routedBy }}</div>
    <div v-if="row.routedBy === 'b2c'">
      {{ row.dispatchTrackDistributionCenter }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'tdDistribution',
  props: ['row'],
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdDistribution.vue